import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { config } from '../config';
import { prepareHeaders } from '../configuration/tokenHandling/prepareHeaders';


export interface Asset {
    tags: string[];
    id: string;
    account_id: string;
    name: string;
    status: string;
    type: string;
    identification: string;
    identification_type: string;
    brand: string;
    license_plate: string;
    license_plate_country_code: string;
}

export interface EmbeddedData {
    tags: Tags;
}

export interface Tags {
    items: TagItem[];
}

export interface TagItem {
    id: string;
}

interface ResponseAssets {
    items: Asset[];
}

export const assetsApi = createApi({
    reducerPath: 'assetsApi',
    baseQuery: fetchBaseQuery({
      baseUrl: config.backend.ASSETS_SERVICE,
      prepareHeaders
    }),
    endpoints: builder => ({
        getAssets: builder.query<ResponseAssets, void>({
          query: () => {
            const queryParams = new URLSearchParams({
              compressed: 'true'
            }).toString();
            return `/v2/assets?${queryParams}`;
          },
        }),
      }),
    });

// Exportando o hook gerado automaticamente
export const { useGetAssetsQuery } = assetsApi;